/**
 * feat-307-redesign-tenant-mgmt — the class strings the sidebar-tree layout
 * reuses. Every colour is a develop token (tailwind.config.js, bound in
 * .team/design/system/tokens.md); these are the same strings the style-1
 * mockup (design/shared/common.js `C.cls`) was built from.
 */
export const cls = {
  card: 'bg-white rounded-2xl border border-softBorder shadow-sm',
  h2: 'font-display text-lg font-semibold text-ink',
  eyebrow: 'text-[11px] font-bold uppercase tracking-wide text-inkMuted',
  btnPrimary:
    'inline-flex items-center gap-1.5 rounded-lg bg-coral text-white px-3 py-1.5 text-sm font-bold hover:brightness-95 whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed',
  btnSecondary:
    'inline-flex items-center gap-1.5 rounded-lg bg-white border border-softBorder text-ink px-3 py-1.5 text-sm font-bold hover:bg-cream-dark whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed',
  btnGhost:
    'inline-flex items-center gap-1.5 rounded-lg text-ink px-2 py-1 text-sm font-semibold hover:bg-cream-dark whitespace-nowrap',
  input:
    'w-full px-3 py-2 rounded-lg border border-softBorder bg-white text-sm focus:outline-none focus:ring-2 focus:ring-coral/40',
  muted: 'text-sm text-inkMuted',
  th: 'py-2 px-3 text-left text-[11px] font-bold uppercase tracking-wide text-inkMuted whitespace-nowrap',
  td: 'py-2.5 px-3 text-sm text-ink',
  act: 'text-sm font-semibold text-coral hover:underline',
  actDanger: 'text-sm font-semibold text-danger-text hover:underline',
};

export const fmtDate = (iso: string | null | undefined): string =>
  iso ? new Date(iso).toLocaleDateString() : 'N/A';
